// Cookie management utility for game settings

export const setCookie = (name, value, days = 30) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
};

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// Game settings specific functions
export const saveGameSettings = (settings) => {
  try {
    const settingsJson = JSON.stringify(settings);
    console.log('🍪 Saving game settings to cookie:', settings);
    setCookie('gameSettings', settingsJson, 365); // Save for 1 year
    console.log('🍪 Cookie saved successfully');
    return true;
  } catch (error) {
    console.error('Error saving game settings to cookie:', error);
    return false;
  }
};

export const loadGameSettings = () => {
  try {
    const settingsJson = getCookie('gameSettings');
    console.log('🍪 Loading game settings from cookie:', settingsJson);
    if (settingsJson) {
      const settings = JSON.parse(settingsJson);
      console.log('🍪 Parsed settings:', settings);
      return settings;
    }
    console.log('🍪 No saved settings found');
    return null;
  } catch (error) {
    console.error('Error loading game settings from cookie:', error);
    return null;
  }
};

export const clearGameSettings = () => {
  deleteCookie('gameSettings');
};

// Test function to verify cookies are working
export const testCookieFunctionality = () => {
  console.log('🧪 Testing cookie functionality...');
  
  // Test basic cookie operations
  setCookie('testCookie', 'testValue', 1);
  const testValue = getCookie('testCookie');
  console.log('🧪 Test cookie value:', testValue);
  
  if (testValue === 'testValue') {
    console.log('✅ Basic cookie functionality works');
    deleteCookie('testCookie');
    return true;
  } else {
    console.log('❌ Basic cookie functionality failed');
    return false;
  }
};
